import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["projectType", "projectTypeParams", "currentActionState", "isExpired"];
import { useTranslation } from "@crehana/i18n";
import AlertCircle from "@crehana/icons/outline/AlertCircle";
import CheckmarkCircle2 from "@crehana/icons/outline/CheckmarkCircle2";
import Edit from "@crehana/icons/outline/Edit";
import Eye from "@crehana/icons/outline/Eye";
import { StateTag, TextTag } from "@crehana/ui";
import getProjectType from "../../../Graphql/Parsers/getProjectType";
import { StatusProjectEnum } from "../../../Graphql/types/globals";
import { PROJECT_STATE_TAG_TRANSLATION_KEY } from "./constants";
import locales from "./i18n";
import { jsx as _jsx } from "react/jsx-runtime";
export var ProjectStateTag = function ProjectStateTag(_ref) {
  var projectType = _ref.projectType,
    projectTypeParams = _ref.projectTypeParams,
    currentActionState = _ref.currentActionState,
    isExpired = _ref.isExpired,
    tagProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(PROJECT_STATE_TAG_TRANSLATION_KEY),
    t = _useTranslation.t,
    addResourceBundle = _useTranslation.addResourceBundle;
  addResourceBundle(locales);
  if (!projectType && !projectTypeParams) {
    // You need to provide either the projectType or the projectTypeParams
    return null;
  }
  var type = projectType || getProjectType(_objectSpread(_objectSpread({}, projectTypeParams), {}, {
    project: {
      currentActionState: currentActionState
    }
  }));
  if (type === 'free' || type === 'participation') {
    return /*#__PURE__*/_jsx(TextTag, _objectSpread({
      label: type === 'free' ? t('FREE_COURSE') : t('PARTICIPATION_PROJECT')
    }, tagProps));
  }
  var currentStatus = currentActionState || StatusProjectEnum.PUBLISHED;
  if (currentStatus === StatusProjectEnum.FINISHED) {
    return /*#__PURE__*/_jsx(TextTag, _objectSpread({
      label: t('FINISHED'),
      leftIcon: {
        component: CheckmarkCircle2
      }
    }, tagProps));
  }
  var icon = AlertCircle;
  var stateType = 'red';
  var labelKey = isExpired ? 'EXPIRED' : 'DRAFT';
  if (currentStatus === StatusProjectEnum.CERTIFIED) {
    if (type === 'teacher') {
      return /*#__PURE__*/_jsx(TextTag, _objectSpread({
        label: t('TEACHER_PROJECT')
      }, tagProps));
    }
    icon = CheckmarkCircle2;
    stateType = 'green';
    labelKey = type === 'degree' || type === 'degree-final' ? 'APPROVED' : 'CERTIFIED';
  }
  if (currentStatus === StatusProjectEnum.PUBLISHED) {
    icon = Eye;
    stateType = 'orange';
    labelKey = 'PUBLISHED';
  }
  if (currentStatus === StatusProjectEnum.OBSERVED && !isExpired) {
    icon = Edit;
    stateType = 'yellow';
    labelKey = 'OBSERVED';
  }
  return /*#__PURE__*/_jsx(StateTag, _objectSpread({
    type: stateType,
    label: t(labelKey),
    leftIcon: {
      component: icon
    }
  }, tagProps));
};
export default ProjectStateTag;